import { finalProjectProposalLink } from '../Activities/FinalProjectProposal'
import { oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { architectureDesignLewisPhase3Link } from '../Activities/ArchitectureDesignLewis'
import { initialPost } from './AL00000Sprint00'

import { learningObjectivesIntro, activitiesListIntro, standardActivities, standardActivitiesClosing, estimated, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'

export const al61200Sprint07 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Develop UML structural as well behavior architectural models</li>
		</ul>

		{list61200Sprint07(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint07 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, architectureDesignLewisPhase3Link(), oreillyPlaylistSA(), false)}
			<li>Review and update your team’s {finalProjectProposalLink()}</li>
			<li>Read “Software Architecture in Practice (SAP) - Chapter 28: Epilogue”</li>
			{initialPost(sprint)}
			<li>Within {oreillyPlaylistSA()} read chapters 1 and 2 of “Cloud Native,” “Docker Up & Running,”, and “Cloud Native Go”</li>
			{standardActivitiesClosing(sprint, architectureDesignLewisPhase3Link(), estimated('12 hours'))}
		</ol>
	</div> )
}